import { useAuth0 } from '@auth0/auth0-react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import Pets from './pages/Pets'
import Profile from './pages/Profile'
import Callback from './pages/Callback'
import Debug from './pages/Debug'
import NotFound from './pages/NotFound'
import TagScan from './pages/TagScan'
import Privacy from './pages/Privacy'
import AcceptInvite from './pages/AcceptInvite'
import Layout from './components/Layout/Layout'
import LoadingSpinner from './components/Common/LoadingSpinner'

function App() {
  const { isLoading, isAuthenticated, error } = useAuth0()

  useEffect(() => {
    if (error) {
      console.error('Auth0 error:', error)
    }
  }, [error])

  if (isLoading) {
    return <LoadingSpinner />
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="tag/:code" element={<TagScan />} />
        <Route path="invite/:token" element={<AcceptInvite />} />
        <Route path="callback" element={<Callback />} />
        <Route
          path="dashboard"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/" replace />}
        />
        <Route
          path="pets"
          element={isAuthenticated ? <Pets /> : <Navigate to="/" replace />}
        />
        <Route
          path="profile"
          element={isAuthenticated ? <Profile /> : <Navigate to="/" replace />}
        />
        <Route
          path="privacy"
          element={isAuthenticated ? <Privacy /> : <Navigate to="/" replace />}
        />
        <Route
          path="debug"
          element={isAuthenticated ? <Debug /> : <Navigate to="/" replace />}
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
